import {
  PageComponentProps,
  isInPlaceEditingActive,
  provideComponent
} from "scrivito"
import { NoComponentPage } from "shared/ui/no-component-page/NoComponentPage"

import { ProductGroupPage } from "./Components/ProductGroupPage"
import {
  ProductGroupAttributes,
  ProductGroupObjClass
} from "./ProductGroupObjClass"

provideComponent(
  ProductGroupObjClass,
  (props: PageComponentProps<ProductGroupAttributes>) => {
    if (isInPlaceEditingActive()) {
      return <NoComponentPage />
    }
    return <ProductGroupPage {...props} />
  }
)
